import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAppSelector } from '../store';
import SignIn from '../pages/SignIn';
import DriverPortal from '../pages/DriverPortal';
import LoadBoard from '../pages/LoadBoard';
import DataEntryPage from '../pages/DataEntryPage';
import PendingLoads from '../pages/PendingLoads';
import DriverPayments from '../pages/DriverPayments';
import AdminUserManagement from '../pages/AdminUserManagement';
import ComingSoon from '../pages/ComingSoon';
import Reports from '../pages/Reports';
import AdminRoute from '../components/AdminRoute';
import DriverRoute from '../components/DriverRoute';

interface AppRoutesProps {
  onFormSubmit: (entries: any[]) => Promise<Blob>;
}

const AppRoutes: React.FC<AppRoutesProps> = ({ onFormSubmit }) => {
  const { user } = useAppSelector((state) => state.auth);

  return (
    <Routes>
      <Route 
        path="/" 
        element={
          user ? (
            <Navigate to="/pending-loads" replace />
          ) : (
            <Navigate to="/signin" replace />
          )
        } 
      />
      <Route 
        path="/signin" 
        element={
          !user ? (
            <SignIn onSignIn={() => {}} />
          ) : (
            <Navigate to="/pending-loads" replace />
          )
        } 
      />
      <Route 
        path="/driver-portal" 
        element={
          <DriverRoute>
            <DriverPortal />
          </DriverRoute>
        } 
      />
      <Route 
        path="/load-board" 
        element={
          <AdminRoute>
            <LoadBoard />
          </AdminRoute>
        } 
      />
      <Route 
        path="/data-entry" 
        element={
          <AdminRoute>
            <DataEntryPage onFormSubmit={onFormSubmit} />
          </AdminRoute>
        } 
      />
      <Route 
        path="/pending-loads" 
        element={
          user ? (
            <PendingLoads />
          ) : (
            <Navigate to="/signin" replace />
          )
        } 
      />
      <Route 
        path="/payments" 
        element={
          user ? (
            <DriverPayments />
          ) : (
            <Navigate to="/signin" replace />
          )
        } 
      />
      <Route 
        path="/admin/users" 
        element={
          <AdminRoute>
            <AdminUserManagement />
          </AdminRoute>
        } 
      />
      <Route
        path="/reports"
        element={
          user ? (
            <Reports />
          ) : (
            <Navigate to="/signin" replace />
          )
        }
      />
      <Route
        path="/settings"
        element={
          user ? (
            <ComingSoon
              title="Settings"
              description="Company, template and notification preferences will live here. Nothing is wired up yet."
            />
          ) : (
            <Navigate to="/signin" replace />
          )
        }
      />
    </Routes>
  );
};

export default AppRoutes; 